/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 10:32:52
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */
export default ({ title, list = [], color = [] }) => {
  return {
    title: {
      text: title,
      textAlign: 'center',
    },
    color,
    legend: {
      show: false,
    },
    tooltip: {
      formatter:  ['{b}', '条数：{c}', '占比：{d}%'].join('<br/>'),
    },
    series: [
      {
        type: 'pie',
        data: list,
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 1
        },
        label: {
          show: false,
        }
      }
    ]
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P2/chart.js